import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type { TranslatableNameWithType } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type {
    FilterNameResolver } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import {
    FilterType,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import type UISignalDataDeps from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignalDataDeps";
import filterNamingService from "../filterNamingService";

function createIntentTopicsNameFactory(): FilterNameResolver {
    return {
        buildName<F extends SignalFilters & { topics: readonly string[] }>(
            filters: F,
            options: UISignalDataDeps["intentSignalSelectedTopics"],
            translationOptions = { i18nKeyModifier: FilterType.IntentTopics },
        ): Readonly<TranslatableNameWithType> {
            const numberOfOptions = options.length;

            return filterNamingService.buildNameForSelection({
                values: filters.topics,
                numberOfOptions,
                translationOptions,
            });
        },
    };
}

export default createIntentTopicsNameFactory;
